import { compose } from '@fluentui/react-bindings';
import { commonPropTypes } from '../../utils';
import { Box } from '../Box/Box';
export var listItemHeaderClassName = 'ui-list__itemheader';

/**
 * Provides a header for the ListItem.
 */
export var ListItemHeader = /*#__PURE__*/function () {
  var ListItemHeader = compose(Box, {
    className: listItemHeaderClassName,
    displayName: 'ListItemHeader',
    mapPropsToStylesProps: function mapPropsToStylesProps(_ref) {
      var hasContent = _ref.hasContent,
        hasHeaderMedia = _ref.hasHeaderMedia,
        truncate = _ref.truncate;
      return {
        hasContent: hasContent,
        hasHeaderMedia: hasHeaderMedia,
        truncate: truncate
      };
    },
    handledProps: ['hasContent', 'hasHeaderMedia', 'truncate'],
    overrideStyles: true,
    shorthandConfig: {
      mappedProp: 'content'
    }
  });
  ListItemHeader.propTypes = commonPropTypes.createCommon();
  return ListItemHeader;
}();
//# sourceMappingURL=ListItemHeader.js.map
